import { render, staticRenderFns } from "./CommonSecretRequestForm.vue?vue&type=template&id=b6304054&scoped=true&"
import script from "./CommonSecretRequestForm.vue?vue&type=script&lang=js&"
export * from "./CommonSecretRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonSecretRequestForm.vue?vue&type=style&index=0&id=b6304054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6304054",
  null
  
)

export default component.exports